<template>
    <div class="content">
      <md-card>
        <md-card-content>
          <b-container fluid>
            <!-- User Interface controls -->
            <b-row class="qidiruv">
              <b-col class="mb-2">
                <b-button
                  class="qoshishBtn"
                  variant="primary"
                  @click="create"
                >
                  <span>
                    <b-icon icon="plus-circle-fill" color="#fff"></b-icon>
                    {{ $t("Қўшиш") }}
                  </span>
                </b-button>
              </b-col>
  
              <b-col lg="7">
                <b-form-group
                  label-for="filter-input"
                  label-cols-sm="1"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filter-input"
                      v-model="filter"
                      type="search"
                      :placeholder="$t('Қидирув')"
                    ></b-form-input>
  
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        variant="danger"
                        @click="filter = ''"
                        >{{ $t("Тозалаш") }}</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-tabs content-class="mt-3">
              <b-tab title="Жарималар" active>
                <div class="tables">
                  <b-table
                    id="room-table"
                    ref="refUserTable"
                    hover
                    striped
                    primary-key="id"
                    :items="penalties"
                    :fields="translatedFields"
                    :filter="filter"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @row-clicked="RowClicked"
                    sort-icon-left
                    stacked="md"
                    show-empty
                    small
                  >
                    <template #cell(№)="data">
                      {{ data.index + 1 }}
                    </template>
      
                    <template #cell(actions)="row" class="lg-1">
                      <b-row class="ml-1">
                        <section
                          style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
                        >
                          <div style="display: flex;">
                            <b-button
                              variant="outline-primary"
                              @click="roomLink(row.item.id)"
                              class="pencil"
                            >
                              <b-icon
                                style="width: 15px;"
                                variant="outline-primary"
                                icon="pencil-fill"
                                aria-hidden="true"
                              ></b-icon>
                            </b-button>
                            <div style="margin-left: 10px;">
                              <b-button
                                class="trash"
                                style=""
                                variant="outline-danger"
                                @click="trash(row.item.id)"
                              >
                                <b-icon
                                  style="width: 15px;"
                                  icon="trash-fill"
                                  aria-hidden="true"
                                ></b-icon>
                              </b-button>
                            </div>
                          </div>
                        </section>
                      </b-row>
                    </template>
                  </b-table>
                </div>
              </b-tab>
              <b-tab title="Бонуслар">
                <div class="tables">
                  <b-table
                    id="room-table"
                    ref="refUserTable"
                    hover
                    striped
                    primary-key="id"
                    :items="bonuses"
                    :fields="translatedFields"
                    :filter="filter"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @row-clicked="RowClicked"
                    sort-icon-left
                    stacked="md"
                    show-empty
                    small
                  >
                    <template #cell(№)="data">
                      {{ data.index + 1 }}
                    </template>
      
                    <template #cell(actions)="row" class="lg-1">
                      <b-row class="ml-1">
                        <section
                          style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
                        >
                          <div style="display: flex;">
                            <b-button
                              variant="outline-primary"
                              @click="roomLink(row.item.id)"
                              class="pencil"
                            >
                              <b-icon
                                style="width: 15px;"
                                variant="outline-primary"
                                icon="pencil-fill"
                                aria-hidden="true"
                              ></b-icon>
                            </b-button>
                            <div style="margin-left: 10px;">
                              <b-button
                                class="trash"
                                style=""
                                variant="outline-danger"
                                @click="trash(row.item.id)"
                              >
                                <b-icon
                                  style="width: 15px;"
                                  icon="trash-fill"
                                  aria-hidden="true"
                                ></b-icon>
                              </b-button>
                            </div>
                          </div>
                        </section>
                      </b-row>
                    </template>
                  </b-table>
                </div>
              </b-tab>
            </b-tabs>
           
          </b-container>
        </md-card-content>
      </md-card>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  export default {
    name: "Index",
    components: {},
    data() {
      return {
        items: [],

        fields: [
          "№",
          { key: "cause", label: "Сабаб", sortable: true },
          { key: "min_time", label: "Дан (Минут)", sortable: true },
          { key: "max_time", label: "Гача (Минут)", sortable: true },
          { key: "summa", label: "Сумма", sortable: true },
          { key: "actions", label: "" }
        ],
        translatedFields: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 100,
        sortBy: "",
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        filterOn: ["user_name", "role"]
      };
    },
    watch: {
      "$i18n.locale": {
        immediate: true,
        handler() {
          this.updateTranslatedFields();
        }
      }
    },
    mounted() {
      this.updateTranslatedFields();
      this.data();
    },
    computed: {
      penalties() {
        return this.items.filter((val) => val.type == 'penalty');
      },
      bonuses() {
        return this.items.filter((val) => val.type == 'bonus');
      }
    },
    methods: {
      updateTranslatedFields() {
        this.translatedFields = this.fields.map(field => {
          return {
            ...field,
            label: this.$t(field.label)
          };
        });
      },
      trash(id) {
        let self = this;
        axios({
          method: "delete",
          url: "/penalty-bonus/delete/" + id
        }).then(res => {
          if (res != undefined) {
            self.data()
          }
        });
      },
      RowClicked(item) {
        this.$router.push({ path: "/penalty-bonus-update/" + item.id });
      },
      roomLink(id) {
        if (id != 1) {
          return this.$router.push({ path: "penalty-bonus-update/" + id });
        }
      },
      create() {
        return this.$router.push({ path: "penalty-bonus-create" });
      },
      data() {
        let s = this;
        axios({
          method: "get",
          url: "/penalty-bonus/all"
        }).then(res => {
          if (res != undefined) {
            s.items = res.data.data;
            s.totalRows = s.items.length;
          }
        });
      },
    }
  };
  </script>
  <style>
  .qidiruv {
    display: flex;
    justify-content: space-between;
  }
  .tables {
    overflow-y: auto;
    overflow-x: hidden;
    height: 1000px;
  }
  .content {
    margin-top: -60px;
  }
  .qoshishBtn {
    display: flex;
    border-radius: 8px;
  }
  .pencil {
    width: 35px;
    height: 35px;
    display: flex;
    background: #fff;
    border: 1px solid #e9f1fa;
    justify-content: center;
    border-radius: 50%;
    align-items: center;
  }
  </style>
  